export enum EasyTetherStateType {
    'trade' = 'trade',
    'depositirt' = 'depositirt',
    'receipt' = 'receipt',
    'preprocess' = 'preprocess',
    'depositusdt' = 'depositusdt',
}
